import { InjectionToken } from '@angular/core';
import { ProjectDisplayConfig } from './config.model';

export const PROJECT_DISPLAY_CONFIG = new InjectionToken<ProjectDisplayConfig>('PROJECT_DISPLAY_CONFIG');
